// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	BoostPFS.inject(this);

	// ANDRE FIX - Normalizar URL con page=1 si no viene en la query
	(function() {
	try {
		var url = new URL(window.location.href);

		// Si no existe el parámetro page en la URL visible
		if (!url.searchParams.has('page')) {
		url.searchParams.set('page', '1');
		// Actualiza la URL en la barra sin recargar la página
		window.history.replaceState({}, '', url.toString());
		}
	} catch (e) {
		console && console.warn && console.warn('No se pudo normalizar page=1 en la URL', e);
	}
	})();
	
	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
})();